
export default class ValidationError extends Error {
    public readonly error: Error;
    public fieldErrors: Record<string, string[]>;

    constructor(fieldErrors: Record<string, string[]>) {
        super();
        this.fieldErrors = fieldErrors;
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(this, new.target.prototype);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/errors/network/ValidationError.ts